import React from 'react';
import classNames from 'classnames';
import Datetime from 'react-datetime';
import { makeStyles } from '@material-ui/core';
import styles from 'assets/jss/material-dashboard-pro-react/components/customDatePickerStyle';
import CustomInput from 'components/CustomInput/CustomInput';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { InputBaseComponentProps } from '@material-ui/core/InputBase/InputBase';

interface IDatePickerProps {
	disabled?: boolean;
	label?: string;
	error?: boolean;
	helperText?: string;
	timeFormat?: string | boolean;
	value?: moment.Moment | string | null;
	onChange: (date: moment.Moment | string) => void;
	inputProps?: any;
	isValidDate?: (date: moment.Moment) => boolean;
	className?: string;
	dateFormat?: string;
	readOnly?: boolean;
}

const CustomDatePicker = (pickerProps: IDatePickerProps) => {
	const classes = makeStyles(styles)();
	const locale = useSelector((state: types.redux.rootReducer) =>
		state.settings.langugage === 'EN' ? 'en-us' : state.settings.langugage
	);

	const Input = (inputProps: InputBaseComponentProps) => (
		<CustomInput
			formControlProps={{
				fullWidth: true,
				className: classNames({ [classes.formControl]: !pickerProps.label }),
			}}
			error={pickerProps.error}
			helperText={pickerProps.helperText}
			labelText={pickerProps.label}
			inputProps={inputProps}
		/>
	);

	if (pickerProps.disabled) {
		return <Input disabled />;
	} else {
		return (
			<Datetime
				closeOnSelect={true}
				locale={locale}
				renderDay={(props, currentDate) => (
					<td {...props}>
						<div className={classes.cell}>{currentDate.date()}</div>
					</td>
				)}
				// @ts-ignore
				renderInput={(props: any) => <Input {...props} disabled={pickerProps.readOnly} />}
				timeFormat={pickerProps.timeFormat}
				{...pickerProps}
				open={pickerProps.readOnly ? false : undefined}
			/>
		);
	}
};
export default CustomDatePicker;
